import { AccomodationEnum } from '../../types/enums/accomodation-type/accomodation-type'
import { CenterOlPaymentStatusEnum } from '../../types/enums/center-ol-payment/center-ol-payment-status.enum'
import { CenterOlPaymentTypeEnum } from '../../types/enums/center-ol-payment/center-ol-payment-type.enum'
import { CurrencyEnum } from '../../types/enums/common/currency.enum'
import { OLTypeEnum } from '../../types/enums/ol/ol-type.enum'
import { CenterFilter } from '../../types/models/center/center-filter'

export const transformCentersFiltersToUrl = (filters?: CenterFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countryIds && filters.countryIds.length > 0)
    searchParams.set('countryIds', filters.countryIds.join(','))

  if (filters.accomodations && filters.accomodations.length > 0) {
    searchParams.set('accomodations', filters.accomodations.join(','))
  }
  if (filters.isOlPresent !== undefined) {
    searchParams.set('isOlPresent', String(filters.isOlPresent))
  }
  if (filters.periods && filters.periods.length > 0) {
    searchParams.set('periods', filters.periods.join(','))
  }
  if (filters.departureDateAfter) {
    searchParams.set('departureDateAfter', filters.departureDateAfter)
  }
  if (filters.departureDateBefore) {
    searchParams.set('departureDateBefore', filters.departureDateBefore)
  }
  if (filters.olIds && filters.olIds.length > 0) {
    searchParams.set('olIds', filters.olIds.join(','))
  }
  if (filters.formulas && filters.formulas.length > 0) {
    searchParams.set('formulas', filters.formulas.join(','))
  }
  if (filters.options && filters.options.length > 0)
    searchParams.set('options', filters.options.join(','))

  if (filters.mainOptions && filters.mainOptions.length > 0)
    searchParams.set('mainOptions', filters.mainOptions.join(','))

  if (filters.year) {
    searchParams.set('year', String(filters.year))
  }

  if (filters.centerId) searchParams.append('centerId', filters.centerId.toString())

  if (filters.olTypes && filters.olTypes.length)
    searchParams.append('olTypes', filters.olTypes.join(','))

  if (filters.status) searchParams.append('status', filters.status)

  if (filters.type) searchParams.append('type', filters.type)

  if (filters.currency) searchParams.append('currency', filters.currency)

  if (filters.hasInvoices !== undefined)
    searchParams.append('hasInvoices', filters.hasInvoices.toString())

  if (filters.dateOfPayment) searchParams.append('dateOfPayment', filters.dateOfPayment)

  if (filters.enrollmentsToDiffuse !== undefined)
    searchParams.append('enrollmentsToDiffuse', filters.enrollmentsToDiffuse.toString())

  if (filters.tripBookingToDiffuse !== undefined)
    searchParams.append('tripBookingToDiffuse', filters.tripBookingToDiffuse.toString())

  return searchParams.toString()
}

export const transformUrlToCenterFilters = (searchParams: URLSearchParams): CenterFilter => {
  const filters: CenterFilter = {}

  const countryIds = searchParams.get('countryIds')
  if (countryIds) filters.countryIds = countryIds.split(',').map(Number)

  const accomodations = searchParams.get('accomodations')
  if (accomodations) filters.accomodations = accomodations.split(',') as AccomodationEnum[]

  const isOlPresent = searchParams.get('isOlPresent')
  if (isOlPresent !== null) filters.isOlPresent = isOlPresent === 'true'

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',')

  const departureDateAfter = searchParams.get('departureDateAfter')
  if (departureDateAfter) filters.departureDateAfter = departureDateAfter

  const departureDateBefore = searchParams.get('departureDateBefore')
  if (departureDateBefore) filters.departureDateBefore = departureDateBefore

  const olIds = searchParams.get('olIds')
  if (olIds) filters.olIds = olIds.split(',').map(Number)

  const formulas = searchParams.get('formulas')
  if (formulas) filters.formulas = formulas.split(',')

  const options = searchParams.get('options')
  if (options) filters.options = options.split(',')

  const mainOptions = searchParams.get('mainOptions')
  if (mainOptions) filters.mainOptions = mainOptions.split(',')

  const year = searchParams.get('year')
  if (year) filters.year = Number(year)

  const centerId = searchParams.get('centerId')
  if (centerId) filters.centerId = parseInt(centerId, 10)

  const olTypes = searchParams.get('olTypes')
  if (olTypes) filters.olTypes = olTypes.split(',') as OLTypeEnum[]

  const status = searchParams.get('status')
  if (status) filters.status = status as CenterOlPaymentStatusEnum

  const type = searchParams.get('type')
  if (type) filters.type = type as CenterOlPaymentTypeEnum

  const currency = searchParams.get('currency')
  if (currency) filters.currency = currency as CurrencyEnum

  const hasInvoices = searchParams.get('hasInvoices')
  if (hasInvoices) filters.hasInvoices = hasInvoices === 'true'

  const dateOfPayment = searchParams.get('dateOfPayment')
  if (dateOfPayment) filters.dateOfPayment = dateOfPayment

  const enrollmentsToDiffuse = searchParams.get('enrollmentsToDiffuse')
  if (enrollmentsToDiffuse) filters.enrollmentsToDiffuse = enrollmentsToDiffuse === 'true'

  const tripBookingToDiffuse = searchParams.get('tripBookingToDiffuse')
  if (tripBookingToDiffuse) filters.tripBookingToDiffuse = tripBookingToDiffuse === 'true'

  return filters
}
